var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrecedent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.823,
    height: 17.823,
    viewBox: "0 0 17.823 17.823",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "precedent",
    transform: "translate(-672 -66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_44",
    "data-name": "Groupe 44",
    transform: "translate(167 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_467152",
    "data-name": 467152,
    transform: "translate(522.824 112.824) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M8.912,0a8.912,8.912,0,1,0,8.912,8.912A8.9,8.9,0,0,0,8.912,0Zm0,16.632a7.72,7.72,0,1,1,7.72-7.72A7.7,7.7,0,0,1,8.912,16.632Z",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(7.249 4.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M142.541,88.728l-3.919-3.919a.589.589,0,0,0-.834.834l3.443,3.443-3.443,3.443a.58.58,0,0,0,0,.834.538.538,0,0,0,.417.177,1.847,1.847,0,0,0,.476-.118l3.86-3.86a.538.538,0,0,0,.177-.417A.544.544,0,0,0,142.541,88.728Z",
    transform: "translate(-137.612 -84.632)",
    fill: "#5471a9"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrecedent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/precedent.41275898.svg";
export { ForwardRef as ReactComponent };